import { AfterViewChecked, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConfig } from 'app/app.config';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { CommentService } from 'app/shared/services/commentService';
import { CaseCommentModel } from 'app/shared/models/caseCommentModel';
import { UserService } from 'app/shared/services/userService';
import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventAggregator, EventList } from 'app/shared/utility/EventAggregator';

@Component({
  selector: 'app-case-comment-thread',
  templateUrl: './case-comment-thread.component.html',
  styleUrls: ['./case-comment-thread.component.css']
})
export class CaseCommentThreadComponent extends BaseComponent implements OnInit, AfterViewChecked {
  @ViewChild('commentContainer', {static: false}) container:ElementRef;

  id: string;
  caseId: string;
  ocme: string;
  
  message:string;
  thread:any;
  currentUser:any;
  userRole:string;
  private initialLoad:boolean;
  isSubmitDisabled:boolean;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: CaseCommentThreadInput,
    private dialogRef: MatDialogRef<CaseCommentThreadComponent>,
    private commentService: CommentService, 
    private userService:UserService,
    private snackBar: MatSnackBar,
    appConfig: AppConfig
  ) {
    super(appConfig);
    
    this.id = this.data.id;
    this.caseId = this.data.caseId;
    this.ocme = this.data.ocme;
  }
 

  ngAfterViewChecked(): void {
    this.container.nativeElement.scroll({
      top: this.container.nativeElement.scrollHeight,
      left: 0,
      behavior: this.initialLoad ? 'auto' : 'smooth'
    });

    if(this.initialLoad) this.initialLoad = false;
  }

  ngOnInit(): void {
    var getCommentThreadPromise = null;
    if(this.id) {
      getCommentThreadPromise = this.commentService.GetCommentThreadById(this.id, this.caseId, this.ocme);
    } else {
      getCommentThreadPromise = this.commentService.GetCommentThread(this.caseId, this.ocme);
    }
    getCommentThreadPromise.then(res => {
      this.thread = res;
      this.userService.GetCurrentUser().then(u => { 
        this.currentUser = u.User;
        this.userRole = u.Role;
        this.initialLoad = true;
      });
    });
  }

  submitMessage(){
    if(!this.message) { 
      this.snackBar.open('Please provide a message.', 'close',  {duration: 3000}); 
      return;
    }
    let maxCommentId = Math.max.apply(Math, this.thread.Comments.map(function(o) { return o.CommentId; }));
    let newComment = new CaseCommentModel();
    newComment.CaseId = this.caseId;
    newComment.CommentId = maxCommentId ? (maxCommentId + 1) : 1;
    newComment.CommentMessage = this.message;

    this.isSubmitDisabled = true;
    this.commentService.AddCaseComment(this.ocme, newComment).then(resComment => {
      this.thread.Comments.push(resComment);
      this.message = "";
      this.isSubmitDisabled = false;
    });
  }

  toggleResolved(){
    this.thread.IsResolved = true;

    this.thread.Comments.forEach(comment => {
      comment.IsResolved = true;
    });
    this.updateCommentThread();
  }
  
  updateCommentThread(){
    this.commentService.UpdateCaseCommentThread(this.thread).then(resThread => {
      this.thread = resThread;
    });
  }

  isUserComment(comment:CaseCommentModel):boolean{
    return !comment.IsUserAdmin;
  }

  handleMultiline(msg:string):string{
    if(!msg) return '';

    let m = msg.replace(/\n/g, "<br/>");
    return m;
  }

  onCloseModal(event: any) {
    EventAggregator.publish(EventList.refreshCommentThreadInfos, true);
    EventAggregator.publish(EventList.messageCaseListRefresh, true);
    this.dialogRef.close();
  }
}

interface CaseCommentThreadInput {
  id: string,
  caseId: string,
  ocme: string
}